__turbopack_context__.v({
  "button": "styles-module-scss-module__Delb6G__button",
  "icon": "styles-module-scss-module__Delb6G__icon",
});
